(() => {
  if (window.alphieMobileDismissInstalled) return;
  window.alphieMobileDismissInstalled = true;
  const roots = new Set();
  const css = `
    #lc_text-widget--box.active {
      position:fixed!important;
      top:auto!important;
      bottom:calc(var(--alphie-vv-bottom, 0px) + 12px + env(safe-area-inset-bottom, 0px))!important;
      right:max(12px, env(safe-area-inset-right, 0px))!important;
      left:auto!important;
      width:min(360px, calc(100vw - 24px))!important;
      max-height:calc(var(--alphie-vv-height, 100dvh) - 24px - env(safe-area-inset-bottom, 0px) - env(safe-area-inset-top, 0px))!important;
      min-height:0!important;
      transition:none!important;
      display:flex!important;
      flex-direction:column!important;
      box-sizing:border-box!important;
    }
    .alphie-dismiss-bar {
      display:flex!important; flex:0 0 48px!important; min-height:48px!important;
      align-items:center!important; justify-content:flex-end!important;
      background:transparent!important; padding:2px 8px!important; box-sizing:border-box!important;
    }
    .alphie-dismiss-button {
      display:flex!important; align-items:center!important; justify-content:center!important;
      width:44px!important; height:44px!important; min-width:44px!important;
      border:0!important; border-radius:0!important; box-shadow:none!important;
      background:transparent!important; color:#ffcc4b!important;
      font:700 24px/1 Arial,sans-serif!important; cursor:pointer!important;
      touch-action:manipulation!important; padding:0!important;
    }
    .alphie-dismiss-button::after {
      content:""; width:12px; height:12px;
      border-right:4px solid currentColor; border-bottom:4px solid currentColor;
      transform:translateY(-3px) rotate(45deg);
    }
    .alphie-dismiss-button:focus-visible { outline:3px solid #fff!important; outline-offset:2px!important; }
    #lc_text-widget--box.active .lc_text-widget--formContainer {
      min-height:0!important; overflow-y:auto!important; overscroll-behavior:contain;
    }
  `;
  function viewport() {
    const vv = window.visualViewport;
    const height = vv ? vv.height : window.innerHeight;
    const bottom = vv ? Math.max(0, window.innerHeight - vv.height - vv.offsetTop) : 0;
    roots.forEach(root => {
      root.host.style.setProperty('--alphie-vv-height', height + 'px');
      root.host.style.setProperty('--alphie-vv-bottom', bottom + 'px');
    });
  }
  function enhance(root) {
    const box = root.querySelector('#lc_text-widget--box');
    if (!box || box.querySelector('.alphie-dismiss-bar')) return;
    const bar = document.createElement('div');
    bar.className = 'alphie-dismiss-bar';
    const close = document.createElement('button');
    close.className = 'alphie-dismiss-button';
    close.type = 'button';
    const nativeClose = root.querySelector('[aria-label="Select to close the chat widget"]');
    close.setAttribute('aria-label', nativeClose ? nativeClose.getAttribute('aria-label') : 'Close chat');
    close.addEventListener('click', () => {
      const launcher = root.querySelector('#lc_text-widget--btn');
      if (!box.classList.contains('active') || !launcher) return;
      launcher.click();
      if (!box.classList.contains('active')) launcher.focus({preventScroll:true});
    });
    bar.appendChild(close);
    box.prepend(bar);
  }
  function attach() {
    document.querySelectorAll('chat-widget').forEach(widget => {
      const root = widget.shadowRoot;
      if (!root || roots.has(root)) return;
      roots.add(root);
      const style = document.createElement('style');
      style.id = 'alphie-mobile-dismiss';
      style.textContent = css;
      root.appendChild(style);
      new MutationObserver(() => enhance(root)).observe(root, {childList:true,subtree:true});
      enhance(root);
      viewport();
    });
  }
  new MutationObserver(attach).observe(document.documentElement, {childList:true,subtree:true});
  window.addEventListener('resize', viewport, {passive:true});
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', viewport, {passive:true});
    window.visualViewport.addEventListener('scroll', viewport, {passive:true});
  }
  attach();
})();
